import React from 'react'
import WrappedStoryMobile from './WrappedStoryMobile'
import WrappedStoryDesktop from './WrappedStoryDesktop'
import WrappedPreconnectHints from './WrappedPreconnectHints'

interface Props {
  uuid?: string
  mode?: 'modal' | 'fullPage'
  onClose?: () => void
}

function WrappedStoryContainer({ uuid, mode = 'modal', onClose }: Props): React.ReactElement {
  return (<>
    <WrappedPreconnectHints />
    {mode === 'fullPage' && <WrappedStoryMobile uuid={uuid} onClose={onClose} />}
    {mode === 'modal' && <WrappedStoryDesktop uuid={uuid} onClose={onClose} />}
  </>)
}

export default WrappedStoryContainer
